import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { api } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { ReleaseItems } from "@/components/hub/ReleaseCard";

export const WhatsNew = () => {
  const { t, lang, translating } = useI18n();
  const nav = useNavigate();
  const [rel, setRel] = useState(null);
  useEffect(() => {
    if (translating) return;
    api.get("/releases/unseen").then((r) => setRel(r.data.release)).catch(() => {});
  }, [lang, translating]);
  const close = (goAll) => {
    setRel(null);
    api.post("/releases/seen").catch(() => {});
    if (goAll) nav("/nouveautes");
  };
  return (
    <Dialog open={!!rel} onOpenChange={(o) => !o && close(false)}>
      <DialogContent data-testid="whats-new-dialog" className="bg-[#0a0d1a] border border-[#2f7bff]/40 shadow-[0_0_80px_-20px_rgba(47,123,255,0.9)] max-w-lg max-h-[88vh] overflow-y-auto">
        {rel && (<>
          <div className="flex items-center gap-4">
            <img src="/logo-x.png" alt="" className="w-14 h-auto drop-shadow-[0_0_18px_rgba(58,215,255,0.7)]" />
            <div>
              <div className="cx-label">{t("rel.popup_label")}</div>
              <DialogTitle className="font-display text-3xl font-bold cx-text-grad" data-testid="whats-new-version">V{rel.version}</DialogTitle>
            </div>
          </div>
          <h3 className="font-display text-lg text-white">{rel.title}</h3>
          <DialogDescription className="text-sm text-slate-400">{rel.summary}</DialogDescription>
          <ReleaseItems items={rel.items} testid="whats-new-items" />
          <div className="flex flex-col sm:flex-row gap-3 pt-2">
            <button data-testid="whats-new-close-btn" onClick={() => close(false)} className="cx-btn flex-1 rounded-full py-3 font-display font-semibold">{t("rel.popup_cta")}</button>
            <button data-testid="whats-new-all-btn" onClick={() => close(true)} className="cx-ghost flex-1 rounded-full py-3 text-sm">{t("rel.popup_all")}</button>
          </div>
        </>)}
      </DialogContent>
    </Dialog>
  );
};
